import { lengthRequired, phone, phoneRequired } from '@polvo-labs/form-utils'
import Hidden from '../../components/Form/Fields/Hidden'
import Input from '../../components/Form/Fields/Input'
import Link from '../../components/Form/Fields/link'
import Password from '../../components/Form/Fields/Password'
import FieldType from '../../components/Form/Fields/type'
import { cpfCnpjRequiredValidation, emailRequiredValidation, termsRequiredValidation } from '../../utils/form-validations'

export interface RegisterFormData {
  name: string
  email: string
  phone: string
  password: string
  recaptcha: string
  action: string
  cpf: string
  accept_terms_conditions: string
  accept_privacy_policy: string
  send_updates: string
}

export type RegisterForm = keyof RegisterFormData;
// const timeOut: number | null = null

const fields: FieldType<RegisterForm>[] = [
  {
    name: 'recaptcha',
    data: {},
    component: Hidden,
  },
  {
    name: 'action',
    data: {},
    component: Hidden,
  },
  {
    name: 'name',
    data: {
      icon: 'text',
      label: 'Nome Completo',
    },
    validation: lengthRequired,
    html: {
      maxLength: 100,
      placeholder: 'Nome e sobrenome',
    },
  },
  {
    name: 'cpf',
    data: {
      icon: 'cpf',
      label: 'CPF',
    },
    html: {
      maxLength: 18,
      placeholder: 'Informe seu CPF',
    },
    validation: cpfCnpjRequiredValidation,
  },
  {
    name: 'email',
    data: {
      icon: 'mail',
      label: 'E-mail',
    },
    validation: emailRequiredValidation,
    html: {
      maxLength: 255,
      placeholder: 'nome@email.com',
    },
  },
  // {
  //   name: 'phone',
  //   data: {
  //     icon: 'phone',
  //     label: 'Telefone',
  //   },
  //   validation: phone,
  //   html: {
  //     maxLength: 255,
  //     placeholder: '(xx) xxxxx-xxxx',
  //   },
  // },
  {
    name: 'password',
    component: Password,
    data: {
      icon: 'password',
      label: 'Senha',
    },
    html: {
      maxLength: 255,
      placeholder: 'Digite sua senha',
    },
  },
  {
    name: 'send_updates',
    component: Input,
    data: {
      label: 'Desejo receber informativos de novidades',
    },
    html: { type: 'checkbox', value: true },
  },
  {
    name: 'accept_terms_conditions',
    component: Input,
    data: {
      label: 'Eu aceito os Termos de Utilizaçao',
    },
    html: { type: 'checkbox', value: true },
    validation: termsRequiredValidation,
  },
  {
    name: 'accept_privacy_policy',
    component: Input,
    data: {
      label: '',
    },
    html: { type: 'checkbox', value: true },
    validation: termsRequiredValidation,
  },
]

export default fields
